// import view components associated with routes
import Statistics from "@/views/Statistics";
import Devices from "@/views/Devices";
import Inventory from "@/views/Inventory";
import Login from "@/views/Login";
import ManagedDevices from "@/views/ManagedDevices";
import OpenApplications from "@/views/OpenApplications";
import Warehouses from "@/views/Warehouses";

/**
 * Provides application's routes and the components that
 * serves the given routes
 */
const applicationRoutes = [
    {
        name: "applications",
        path: "/",
        component: Inventory,
        isNavItem: true,
    },
    {
        name: "devices",
        path: "/devices",
        component: Devices,
        isNavItem: true,
    },
    {
        name: "managedDevices",
        path: "/managed-devices",
        component: ManagedDevices,
        isNavItem: true,
    },
    {
        name: "projects",
        path: "/projects",
        component: OpenApplications,
        isNavItem: true,
    },
    {
        name: "statistics",
        path: "/statistics",
        component: Statistics,
        isNavItem: true,
    },
    {
        name: "warehouses",
        path: "/warehouses",
        component: Warehouses,
        isNavItem: true,
    },
];

const routesLoader = product => {
    try {
        return require(`@/assets/settings/routes/${product}.json`);
    } catch {
        return require(`@/assets/settings/routes/default.json`);
    }
};
export default dependencies => {
    const {product} = dependencies;
    let projectRoutes = routesLoader(product);
    let routes = [];
    for (let routeName of projectRoutes) {
        let route = applicationRoutes.find(element => element.name === routeName);
        if (route) {
            routes.push(route);
        }
    }

    //routes mandatory for all projects
    let defaultRoutes = [
        {
            name: "login",
            path: "/login",
            component: Login,
        },
    ];

    return {
        routes: {
            mode: "hash",
            routes: routes.concat(defaultRoutes),
            scrollBehavior: to => {
                if (to.hash) {
                    return {selector: to.hash};
                } else {
                    return {x: 0, y: 0};
                }
            },
        },
    };
};
